document.addEventListener('DOMContentLoaded', () => {
  const elements = document.querySelectorAll('.product-collapsible-content-entry');
  if (elements.length > 0) {
    elements[0].classList.add('active');
  }
});


/* Produktbeschreibung + aufklappbare Inhalte unter den Produktmedien sichtbar halten.
   Ursache: Die App "Variant Image Module" (VIM) ersetzt die Galerie durch ihren eigenen
   VIM-MEDIA-WRAPPER. Eine App-Regel blendet dabei den Theme-Container aus, in den das
   Theme die aufklappbaren Inhalte kopiert. Gegen diese Regel kommt eigenes CSS nicht an
   (sie gewinnt trotz !important), ein Inline-Style dagegen schon.
   Der MutationObserver setzt das erneut, wenn die App die Galerie neu aufbaut.
   Betrifft nur Produkte, auf denen VIM aktiv ist. Stand: 11.09.2026 */
(function () {
  'use strict';
  var SEL = '.product-media-collapsible-content-desktop-container';

  function anwenden() {
    var desktop = window.matchMedia('(min-width: 768px)').matches;
    document.querySelectorAll(SEL).forEach(function (el) {
      if (!desktop) {
        if (el.style.display) el.style.removeProperty('display');
        return;
      }
      if (el.children.length === 0) return;
      if (el.style.display !== 'block') el.style.setProperty('display', 'block', 'important');
    });
  }

  function start() {
    anwenden();
    var medien = document.querySelector('.product-media');
    if (medien && window.MutationObserver) {
      new MutationObserver(anwenden).observe(medien, {
        childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class']
      });
    }
    window.addEventListener('resize', anwenden);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
